import { useMutation } from '@tanstack/react-query'

import { MesureResponseModel } from '@/domain/model/measures'
import { SingleQuestionFiltersModel } from '@/domain/model/question'
import { QUERIES } from '@/enums/queries'

import { globalQueryClient } from '../queryClient'
import {
  updateMeasuresQuestionsByFormId,
  type UpdateMeasuresQuestionsByFormIdProps,
} from './services/updateMeasuresQuestionsByFormId'

export const useUpdateMeasuresQuestionsByFormId = (
  params: SingleQuestionFiltersModel
) => {
  const mutation = useMutation({
    mutationFn: async (data: UpdateMeasuresQuestionsByFormIdProps) =>
      await updateMeasuresQuestionsByFormId(data),
    onSuccess: (data) => {
      globalQueryClient.setQueryData<MesureResponseModel>(
        [
          QUERIES.MEASURES.LOAD_BY_FORM_AND_CLIENT_ID,
          params.formId,
          params.clientId,
        ],
        (old) => {
          if (!old) return old
          return {
            ...old,
            instructions: data.instructions,
          }
        }
      )
    },
  })

  const updateMeasuresQuestionsByFormIdReq = async (
    data: UpdateMeasuresQuestionsByFormIdProps
  ) => {
    return mutation.mutateAsync(data)
  }

  return {
    updateMeasuresQuestionsByFormId: updateMeasuresQuestionsByFormIdReq,
    ...mutation,
  }
}
